// extracted by mini-css-extract-plugin
export var boxItems = "_bi-1";
export var boxItemsLg = "_bi-2";
export var button = "_bi-7";
export var buttonHoverless = "_bi-9";
export var buttonLg = "_bi-8";
export var filterGroupBox = "_bi-0";
export var icon = "_bi-3";
export var iconSecondary = "_bi-6";
export var iconWrapper = "_bi-4";
export var iconWrapperLg = "_bi-5";
export var truncatedLabel = "_bi-a";